
import { Component, Vue } from "vue-property-decorator";
import {
  createHenganLoadingPlanPackingInfo,
  getHenganLoadingPlanDetail, getHenganLoadingPlanProductAssigned,
  unpackCustomsPackingSet,
  updateHenganCustomsPackingInfo,
  getOriginalPackingInfo
} from "@/api/hengan-loading-plan";
import Pagination from "@/components/Pagination/index.vue";
import ConfigContainerTypeComponent from "@/views/components/ConfigContainerTypeComponent.vue";
import HqPackingListProductList from "@/views/components/HqPackingListProductList.vue";
import {
  CustomsPackingModel,
  HenganLoadingPlanModel,
  HqPackingListModel,
  ProductInfoModel,
  SecondaryPackingInfoModel,
  SecondaryPackingModel
} from "@/model/HenganLoadingPlanModels";
import {
  CustomsPacking,
  HqPackingListDetail,
  ProductInfo,
  SecondaryPacking,
  SecondaryPackingInfo,
  TableRowData
} from "@/model/HqPackingListModels";
import PackingListPackingDetail from "@/views/components/PackingListPackingDetail.vue";
import CreatePackingWizard from "@/views/warehouse-management/components/CreatePackingWizard.vue";
import { groupBy } from "lodash";
import { Message } from "element-ui";

@Component({
  name: "HenganLoadingPlanDetailForWarehouse",
  components: {
    PackingListPackingDetail,
    HqPackingListProductList,
    ConfigContainerTypeComponent,
    Pagination,
    CreatePackingWizard
  }
})
export default class extends Vue {
  private henganLoadingPlanId: string;
  private henganLoadingPlan: HenganLoadingPlanModel =
    new HenganLoadingPlanModel();
  private hqPackingListData: HqPackingListTableRowData[] = [];
  private unpackedProductInfoData: UnpackedProductTableRowData[] = [];
  private editPackageInfoDialogVisible = false;
  private confirmGoodDialogVisible = false;
  private currentEditCustomsPacking: CustomsPacking = new CustomsPacking();
  private currentEditSecondaryPackingInfos: SecondaryPackingInfo[] = [];
  private packingInfoRequest: HenganLoadingPlanPackingInfo = new HenganLoadingPlanPackingInfo();
  private bePackagedInfoDialogVisible = false;
  private originalPackingInfos: OriginalPackingInfo[] = [];
  private productInfosByPacked: ProductInfoByPack[] = [];
  private isInBulk = false;
  private startAlreadyGoodsLoading = false;

  // 是否显示开始备货的对话框
  public showDialogForLoadingGoods = false;
  // 开始备货时，强拆的选项
  // public foredUnpack = false;
  private createPackingWizardVisible = false;

  created() {
    if(this.$route.params.henganLoadingPlanId) {
      this.henganLoadingPlanId = this.$route.params.henganLoadingPlanId;
    } else {
      this.henganLoadingPlanId = this.$route.query.henganLoadingPlanId as any;
    }
    this.getDetail();
  }

  showContentOfNuvolumneOfSecondaryPacking() {
    if (this.packingInfoRequest.packingInfos === undefined) {
      return "";
    }
    const packingCodes = this.packingInfoRequest.packingInfos.filter(info => info.packingType === "S" && info.volume === "0").map(info => info.packingCode);
    if (packingCodes.length === 0) {
      return "";
    }
    return packingCodes.join("、") + " 可能没有次包装体积数据";
  }

  // closeDialog() {
  //   this.foredUnpack = false;
  // }


  private async getDetail() {
    const res: any = await getHenganLoadingPlanDetail(this.henganLoadingPlanId);
    this.henganLoadingPlan = res;
    this.hqPackingListData = this.henganLoadingPlan.hqPackingLists.map(
      (value) => {
        let tableData = new HqPackingListTableRowData(
          value.id,
          value.code,
          value.parentCode,
          value.factoryName,
          value.remark
        );
        tableData.hqPackingListDetail =
          this.convertHenganLoadingPackingListModel2HqPackingListDetail(value);
        return tableData;
      }
    );
    this.unpackedProductInfoData = this.henganLoadingPlan.hqPackingLists
      .map((value) => {
        return value.unpackedProductInfos.map(
          (p) =>
            new UnpackedProductTableRowData(value.code, value.factoryName, p)
        );
      })
      .reduce((pre, cur) => pre.concat(cur), []);
    this.unpackedProductInfoData.forEach(value => this.productInfosByPacked.push({
      productId: value.id,
      quantity: value.totalNumberPcs
    }));
  }

  private convertHenganLoadingPackingListModel2HqPackingListDetail(
    henganPackingListModel: HqPackingListModel
  ) {
    const hqPackingListDetail = new HqPackingListDetail();
    Object.assign(hqPackingListDetail, henganPackingListModel);
    hqPackingListDetail.customsPackingSet =
      henganPackingListModel.customsPackingSet.map((value) =>
        this.convertHenganCustomsPackingToCustomsPacking(value)
      );
    return hqPackingListDetail;
  }

  private convertHenganCustomsPackingToCustomsPacking(
    henganCustomsPacking: CustomsPackingModel
  ): CustomsPacking {
    const customsPacking = new CustomsPacking();
    Object.assign(customsPacking, henganCustomsPacking);
    customsPacking.secondaryPackingSet =
      henganCustomsPacking.secondaryPackingSet.map((value) =>
        this.convertHenganSecondaryPacking2SecondaryPacking(value)
      );
    return customsPacking;
  }


  private getSummaries(params) {
    const { columns, data } = params;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = "合计:\n" + data.reduce((pre) => {
          return pre + 1;
        }, 0);
      }
      if (index === 1) {
        sums[index] = "CTN:\n" + data.reduce((pre, cur) => {
          if (!cur.packingCode.includes("次包装") &&
            !cur.packingCode.includes("产品") &&
            cur.packingCode.includes("CTN")) {
            return pre + 1;
          } else {
            return pre;
          }
        }, 0);
      }
      if (index === 2) {
        sums[index] = "PLT:\n" + data.reduce((pre, cur) => {
          if (!cur.packingCode.includes("次包装") &&
            !cur.packingCode.includes("产品") &&
            cur.packingCode.includes("PLT")) {
            return pre + 1;
          } else {
            return pre;
          }
        }, 0);
      }
      if (index === 3) {
        sums[index] = "次包装:\n" + data.reduce((pre, cur) => {
          if (cur.packingCode.includes("次包装")) {
            return pre + 1;
          } else {
            return pre;
          }
        }, 0);
      }
      if (index === 4) {
        sums[index] = "产品:\n" + data.reduce((pre, cur) => {
          if (cur.packingCode.includes("产品")) {
            return pre + 1;
          } else {
            return pre;
          }
        }, 0);
      }
      if (index === 5) {
        sums[index] = "体积:\n" + data.reduce((pre, cur) => {
          return pre + Number(cur.volume);
        }, 0).toFixed(2);
      }
      if (index === 6) {
        sums[index] = "数量:\n" + data.reduce((pre, cur) => {
          return pre + Number(cur.totalProductQuantity);
        }, 0);
      }
      if (index === 7) {
        sums[index] = "价格:\n" + data.reduce((pre, cur) => {
          if(cur.packingType === 'S') { // 次包装
            return pre + Number(cur.totalPrice);
          }
          if(cur.packingType === 'P') { // 产品
            return pre + Number(cur.totalPrice*Number(cur.totalProductQuantity));
          }
          if(cur.packingType === 'C') { // 主包装
            return pre + Number(cur.totalPrice);
          }
        }, 0).toFixed(2);
      }
      if (index === 8) {

      }
    });
    return sums;
  }

  private convertHenganSecondaryPacking2SecondaryPacking(
    henganSecondaryPacking: SecondaryPackingModel
  ): SecondaryPacking {
    const secondaryPacking = new SecondaryPacking();
    Object.assign(secondaryPacking, henganSecondaryPacking);
    secondaryPacking.packingInfos = henganSecondaryPacking.packingInfos.map(
      (value) =>
        this.convertHenganSecondaryPackingInfo2SecondaryPackingInfo(value)
    );
    // secondaryPacking.productInfos = henganSecondaryPacking.packingInfos.map(value => value.productInfos)
    //   .reduce((pre, cur) => pre.concat(cur), [])
    //   .map(value => this.convertHenganProductInfo2ProductInfo(value));
    return secondaryPacking;
  }

  private convertHenganSecondaryPackingInfo2SecondaryPackingInfo(
    henganSecondaryPackingInfo: SecondaryPackingInfoModel
  ): SecondaryPackingInfo {
    const secondaryPackingInfo = new SecondaryPackingInfo();
    secondaryPackingInfo.id = henganSecondaryPackingInfo.id;
    secondaryPackingInfo.secondaryPackingId =
      henganSecondaryPackingInfo.secondaryPackingId;
    secondaryPackingInfo.packingWeight =
      henganSecondaryPackingInfo.packingWeight;
    secondaryPackingInfo.packingVolume =
      henganSecondaryPackingInfo.packingVolume;
    secondaryPackingInfo.productInfos =
      henganSecondaryPackingInfo.productInfos.map((value) =>
        this.convertHenganProductInfo2ProductInfo(value)
      );
    // secondaryPackingInfo.height = henganSecondaryPackingInfo.packingVolume?.height;
    // secondaryPackingInfo.grossWeightPerCarton = henganSecondaryPackingInfo.packingWeight?.grossWeight;
    // secondaryPackingInfo.netWeight = henganSecondaryPackingInfo.packingWeight?.netWeight;
    return secondaryPackingInfo;
  }

  private convertHenganProductInfo2ProductInfo(
    henganProductInfo: ProductInfoModel
  ): ProductInfo {
    const productInfo = new ProductInfo();
    Object.assign(productInfo, henganProductInfo);
    return productInfo;
  }

  private getRowStyle({ row }) {
    return row.loadingFirst ? "success-row" : "";
  }

  private showEditCustomsPackingInfoDialog(row: HqPackingListTableRowData) {
    this.henganLoadingPlan.hqPackingLists.forEach((value) => {
      value.customsPackingSet.forEach((c) => {
        if (c.id === row.id) {
          this.currentEditCustomsPacking =
            this.convertHenganCustomsPackingToCustomsPacking(c);
          this.currentEditSecondaryPackingInfos =
              this.currentEditCustomsPacking.secondaryPackingSet
                  .flatMap(value =>
                      value.packingInfos.map(info => ({
                        ...JSON.parse(JSON.stringify(info)),
                        cartonNumber: value.cartonNumber // 直接覆盖或新增属性
                      }))
                  );
        }
      });
    });
    this.editPackageInfoDialogVisible = true;
  }

  private async onEditCustomsPackingConfirmed() {
    const data: any = {
      grossWeight: this.currentEditCustomsPacking.grossWeight,
      netWeight: this.currentEditCustomsPacking.netWeight,
      length: this.currentEditCustomsPacking.length,
      width: this.currentEditCustomsPacking.width,
      height: this.currentEditCustomsPacking.height,
      henganSecondaryPacking: this.currentEditSecondaryPackingInfos.map(
        (value) => {
          return {
            id: value.id,
            henganSecondaryPackingId: value.secondaryPackingId,
            ...value.packingVolume,
            ...value.packingWeight
            // length: value.length,
            // width: value.width,
            // height: value.height,
            // netWeight: value.netWeight,
            // grossWeight: value.grossWeightPerCarton
          };
        }
      )
    };
    await updateHenganCustomsPackingInfo(
      this.currentEditCustomsPacking.id,
      data
    );
    this.clearEditPackingData();
    this.editPackageInfoDialogVisible = false;
    await this.getDetail();
  }

  private clearEditPackingData () {
    this.currentEditCustomsPacking = null;
    this.currentEditSecondaryPackingInfos = [];
  }

  //确认备货信息
  private async confirmPackingInfo() {
    this.startAlreadyGoodsLoading = true;
    this.showDialogForLoadingGoods = false;
    // this.packingInfoRequest.forced = this.foredUnpack;
    await createHenganLoadingPlanPackingInfo(this.packingInfoRequest, this.henganLoadingPlanId)
      .finally(() => this.startAlreadyGoodsLoading = false);
    this.packingInfoRequest = new HenganLoadingPlanPackingInfo();
    this.confirmGoodDialogVisible = false;
    await this.getDetail();
  }

  // 包装管理
  private selectedCustomsPackingSet: {
    hqPackingListId: string;
    customsPackingIds: string[];
  }[] = [];
  private selectedUnpackedProductInfos: {
    hqPackingListId: string;
    productIds: string[];
  }[] = [];

  private selectHandle(rows,hqPackingListId) {
    const exists = this.selectedCustomsPackingSet.filter(
      (value) => value.hqPackingListId === hqPackingListId
    )[0];
    if (exists) {
      exists.customsPackingIds = rows;
    } else {
      this.selectedCustomsPackingSet.push({
        hqPackingListId: hqPackingListId,
        customsPackingIds: rows
      });
    }
  }

  private onUnpackedProductInfoSelectChange(
    rows: UnpackedProductTableRowData[]
  ) {
    this.selectedUnpackedProductInfos = [];
    const groupedByHqPackingListId: {
      [key: string]: UnpackedProductTableRowData[];
    } = groupBy(rows, (row) => row.hqPackingListId);
    this.selectedUnpackedProductInfos = Object.keys(
      groupedByHqPackingListId
    ).map((value) => {
      return {
        hqPackingListId: value,
        productIds: groupedByHqPackingListId[value].map(
          (value) => value.id
        )
      };
    });
  }

  private openCreatePackingWizard() {
    this.createPackingWizardVisible = true;
  }

  private async onCreatePackingSuccess() {
    this.selectedCustomsPackingSet = [];
    this.selectedUnpackedProductInfos = [];
    await this.getDetail();
    this.resetPackingListSelections();
  }

  private resetPackingListSelections() {
    const packingListDetails = this.$refs.PackingListPackingDetails as any;
    if (!packingListDetails) {
      return;
    }
    const refs = Array.isArray(packingListDetails)
      ? packingListDetails
      : [packingListDetails];
    refs.forEach((ref) => ref.initRadios && ref.initRadios());
  }

  private unpack() {
    if (this.selectedCustomsPackingSet.length < 1) {
      Message.error({ message: "请选择包装" });
      return;
    }
    if (this.selectedUnpackedProductInfos.length > 0) {
      Message.error({ message: "散装产品不能拆" });
      return;
    }

    const msg = ["此操作将拆散主包装，是否拆？", "强拆：子包装即使无重量和体积数据也能拆。", "普拆：子包装无完整数据将不能拆。"];
    const msgData = [];
    const h = this.$createElement;
    for (const i in msg) {
      msgData.push(h("p", null, msg[i]));
    }
    this.$confirm(
      "提示",
      {
        title: "拆托/箱",
        message: h("div", null, msgData),
        distinguishCancelAndClose: true,
        confirmButtonText: "普拆",
        cancelButtonText: "强拆"
      })
      .then(() => {
        this.doUnpack(false);
      })
      .catch(action => {
        if (action === "close") {
          return;
        }
        this.doUnpack(true);
      });

  }

  private async doUnpack(force: boolean) {
    const customsPackingIds = this.selectedCustomsPackingSet
      .map((value) => value.customsPackingIds)
      .reduce((pre, cur) => pre.concat(cur), []);
    await unpackCustomsPackingSet(this.henganLoadingPlanId, customsPackingIds, this.isInBulk, force);
    this.selectedCustomsPackingSet = [];
    this.selectedUnpackedProductInfos = [];
    await this.getDetail();
  }

  private async showHenganLoadingPlanPackingList() {
    const data: any = await getHenganLoadingPlanProductAssigned(this.henganLoadingPlanId);
    this.packingInfoRequest = data;
    this.confirmGoodDialogVisible = true;
  }

  private checkHenganLoadingPlanDetail() {
    this.$router.push({
      name: "HenganLoadingPlanDetail",
      params: { id: this.henganLoadingPlanId }
    });
  }

  private async showNewCustomsPackingDialog(row: HqPackingListTableRowData) {
    const data: any = await getOriginalPackingInfo(row.id);
    this.originalPackingInfos = data;
    this.bePackagedInfoDialogVisible = true;
  }

  private getMax(rowId: string) {
    return this.productInfosByPacked.filter(value => value.productId === rowId)[0].quantity;
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }
}

class HqPackingListTableRowData {
  id: string;
  code: string;
  parentCode: string;
  factoryName: string;
  remark: string;
  hqPackingListDetail: HqPackingListDetail;

  constructor(
    id: string,
    code: string,
    parentCode: string,
    factoryName: string,
    remark: string
  ) {
    this.id = id;
    this.code = code;
    this.parentCode = parentCode;
    this.factoryName = factoryName;
    this.remark = remark;
  }
}

class UnpackedProductTableRowData extends ProductInfoModel {
  hqPackingListId: string;
  hqPackingListCode: string;
  factoryName: string;
  constructor(
    hqPackingListCode: string,
    factoryName: string,
    productInfo: ProductInfoModel
  ) {
    super();
    this.id = productInfo.id;
    this.hqPackingListCode = hqPackingListCode;
    this.hqPackingListId = productInfo.parentId;
    this.factoryName = factoryName;
    this.description = productInfo.description;
    this.declarationDescription = productInfo.declarationDescription;
    this.guestModel = productInfo.guestModel;
    this.hqOrJrNumber = productInfo.hqOrJrNumber;
    this.oeNumber = productInfo.oeNumber;
    this.refNumber = productInfo.refNumber;
    this.totalNumberPcs = productInfo.totalNumberPcs;
    this.loadingFirst = productInfo.loadingFirst;
  }
}

class HenganLoadingPlanPackingInfo {
  henganLoadingPlanId: string;
  henganLoadingPlanCode: string;
  logisticsSpecialistId: string;
  logisticsSpecialistName: string;
  customerId: string;
  customerAbbreviation: string;
  packingInfos: PackingInfo[];
  forced: boolean;
}

class PackingInfo {
  id: string;
  henganLoadingPlanId: string;
  packingId: string;
  packingType: string;
  quantity: number;
  loadingFirst: boolean;
  packingCode: string;
  declarationDescriptions: string;
  volume: string;
  purchaseOrderNumbers: string;
  factoryName: string;
  totalProductQuantity: string;
  totalPrice: string;
  hqPackingListId: string;
  hqPackingListCode: string;
  deliveryNoteId: string;
  deliveryNoteCode: string;
  hqPackingListState: HqPackingListState;
  inventory: string;
  useInventoryQuantity: number;
}

class OriginalPackingInfo {
  oldCustomsPackingCode: string;
  productNames: string;
  hqPackingListCode: string;
  deliveryNoteCode: string;
}

class HqPackingListState {
  name: string;
  desc: string;
  canGetReceiveList: boolean;
  isNotInStorage: boolean;
}

export class ProductInfoByPack {
  productId: string;
  quantity: number;

  constructor(productId: string, quantity: number) {
    this.productId = productId;
    this.quantity = quantity;
  }
}

